/**
 * @generated SignedSource<<603bcd68062968a6bea4121a305f0d29>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductMultipleVariantsRuleInput = {
  attributeCodes: ReadonlyArray<string>;
  bulkAsNameAndNumberEnabled: boolean;
  enableImportCSV: boolean;
  nameAndNumberEnabled: boolean;
  options?: string | null;
  skipOptionForNameAndNumber: boolean;
};
export type productSidePanelContent_DisableBulkVariationMutation$variables = {
  id: string;
  input: ProductMultipleVariantsRuleInput;
};
export type productSidePanelContent_DisableBulkVariationMutation$data = {
  readonly updateProductMultipleVariantsRule: {
    readonly attributeCodes: ReadonlyArray<string>;
    readonly bulkAsNameAndNumberEnabled: boolean;
    readonly enableImportCSV: boolean;
    readonly nameAndNumberEnabled: boolean;
    readonly options: string | null;
    readonly skipOptionForNameAndNumber: boolean;
  };
};
export type productSidePanelContent_DisableBulkVariationMutation = {
  response: productSidePanelContent_DisableBulkVariationMutation$data;
  variables: productSidePanelContent_DisableBulkVariationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "productId",
        "variableName": "id"
      }
    ],
    "concreteType": "ProductMultipleVariantsRule",
    "kind": "LinkedField",
    "name": "updateProductMultipleVariantsRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "attributeCodes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nameAndNumberEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skipOptionForNameAndNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bulkAsNameAndNumberEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enableImportCSV",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "options",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_DisableBulkVariationMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_DisableBulkVariationMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "a61273548ef86b004b92c6bba92e750b",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_DisableBulkVariationMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_DisableBulkVariationMutation(\n  $id: ID!\n  $input: ProductMultipleVariantsRuleInput!\n) {\n  updateProductMultipleVariantsRule(productId: $id, input: $input) {\n    attributeCodes\n    nameAndNumberEnabled\n    skipOptionForNameAndNumber\n    bulkAsNameAndNumberEnabled\n    enableImportCSV\n    options\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe9b8ff24c2d7c91d97935f1a64578cd";

export default node;
